import type { GemXVariantBadgeKey, GemXVariantBadgeProps } from '../types';

export const VARIANT_BADGE_PRESET: Record<
  GemXVariantBadgeKey,
  Pick<GemXVariantBadgeProps, 'variant' | 'label' | 'tone'>
> = {
  ORIGIN: {
    variant: 'A',
    label: 'Origin',
    tone: 'origin',
  },
  VARIANT: {
    variant: 'B',
    label: 'Variant',
    tone: 'variant',
  },
};
